import {
  BrowserPersistence 
} from "@/util"
import {
  gql 
} from "@apollo/client"

const storage = new BrowserPersistence()

/**
 * Custom type policies necessary for the currency query.
 */
export const CUSTOM_TYPES = {
  Currency: {
    fields: {
      /**
             * @client field policies must be defined if queried along server
             * props or the entire query will return null.
             */
      current_currency_code: {
        read(_, {
          readField 
        }) {
          return (
            storage.getItem("store_view_currency") ||
                        readField("default_display_currency_code")
          )
        },
      },
    },
  },
}

export const GET_CURRENCY_DATA = gql`
    query getCurrencyData {
        currency {
            current_currency_code @client
            default_display_currency_code
            available_currency_codes
        }
    }
`

export default {
  queries: {
    getCurrencyData: GET_CURRENCY_DATA,
  },
}
